import { ComparisonType } from '@openx/types/targeting/targetingValuesTypes.ts';
import {
  type TechnologyAndDevicesFormState,
  TechnologyAndDevicesOption,
} from '@openx/types/targeting/technologyAndDevices.ts';
import { useTranslation } from 'react-i18next';
import { SelectedItems } from '../../shared/SelectedItems/SelectedItems.tsx';
import { getCookiesLabelsMap, getDeviceIdLabelsMap, getHttpsLabelsMap } from '../utils.ts';

type SelectedItemsSingleOptionProps = {
  filtersTitle: string;
  selectedItems: TechnologyAndDevicesFormState;
  readonly: boolean;
  handleChange: (values: string[]) => void;
  dataTest: string;
  selectedType: TechnologyAndDevicesOption;
};

export const SelectedItemsSingleOption = ({
  filtersTitle,
  selectedItems,
  readonly,
  handleChange,
  dataTest,
  selectedType,
}: SelectedItemsSingleOptionProps) => {
  const { t } = useTranslation();
  const cookiesOptionsLabels = getCookiesLabelsMap(t);
  const deviceIdOptionsLabels = getDeviceIdLabelsMap(t);
  const httpsOptionsLabels = getHttpsLabelsMap(t);
  const { op } = selectedItems[selectedType];

  const optionsMap = {
    [TechnologyAndDevicesOption.DEVICE_ID]: deviceIdOptionsLabels,
    [TechnologyAndDevicesOption.HTTPS]: httpsOptionsLabels,
    [TechnologyAndDevicesOption.MKT_COOKIES]: cookiesOptionsLabels,
  };

  return (
    <SelectedItems
      filtersTitle={filtersTitle}
      isAddIcon={op === ComparisonType.EQUALS}
      selectedItems={[op]}
      readonly={readonly}
      handleChange={handleChange}
      options={optionsMap[selectedType]}
      dataTest={dataTest}
    />
  );
};
